import { render } from "./openingBalance.vue?vue&type=template&id=13e1650f&scoped=true"
import script from "./openingBalance.vue?vue&type=script&lang=js"
export * from "./openingBalance.vue?vue&type=script&lang=js"

import "./openingBalance.vue?vue&type=style&index=0&id=13e1650f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e1650f"]])

export default __exports__